<template>
  <div class="bg-light" v-if="device">
    <table class="table table-responsive-sm table-striped">
      <tr>
        <th>{{$t('serial')}}</th>
        <td>
          <span v-text="device.serial"></span>
        </td>
      </tr>
      <tr v-if="device.tracker_config.requested_mode">
        <th>{{$t('requested_mode')}}</th>
        <td>{{device.tracker_config.requested_mode|niceMode}}</td>
        <td>{{$t('mode_applied_next_communication_from_tracker')}}</td>
      </tr>
      <tr v-if="allow_edit&&allow_change_mode">
        <th>{{$t('mode')}}</th>
        <td v-if="modes.length">
          <multiselect
            class="input-nvx my-0"
            v-model="current_mode"
            :searchable="false"
            :options="modes"
            :multiple="false"
            :allow-empty="false"
            :select-label="$t('select')"
            :selected-label="$t('selected')"
            :deselect-label="$t('deselect_label')"
            :custom-label="mode_label"
          ></multiselect>
        </td>
        <td>
          <button
            class="btn btn-sm btn-primary"
            v-on:click="request_mode_change()"
          >{{$t('request_mode')}}</button>
        </td>
      </tr>
      <tr v-if="allow_sct2_config">
        <th>{{$t('location_period_move')}}</th>
        <td>
          <input
            type="range"
            id="move_loc_period"
            min="2"
            max="1440"
            v-model="sct2_config.move_loc_period"
          />
          <input type="text" v-model="sct2_config.move_loc_period" />
          {{$t('minuts')}}
        </td>
        <td v-if="sct2_config.msg">
          <span v-text="sct2_config.msg"></span>
        </td>
      </tr>
      <tr v-if="allow_sct2_config">
        <th>{{$t('location_period_stationary')}}</th>
        <td>
          <input
            type="range"
            id="keepalive_period"
            min="2"
            max="1440"
            v-model="sct2_config.keepalive_period"
          />
          <input type="text" v-model="sct2_config.keepalive_period" />
          {{$t('minuts')}}
        </td>
        <td>
          <button
            class="btn btn-sm btn-primary"
            v-on:click="request_sct2_change()"
          >{{$t('request_mode')}}</button>
        </td>
      </tr>
      <tr v-if="allow_edit">
        <th>{{$t('name')}}</th>
        <td>
          <div class="form-inline">
            <input class="form-control-sm" v-model="device.name" />
            <button class="btn btn-sm btn-primary" v-on:click="save_device()">{{$t('Save')}}</button>
          </div>
        </td>
      </tr>
      <tr v-if="allow_edit">
         <th>{{$t('avatar')}}</th>
        <td>
          <div class="form-inline">

            <div class="profil border border-dark rounded-pill" @click="showModal=true" :style="{ backgroundImage: selectedIcon <= 50 && selectedIcon >= 0 ? 'url(' + avatars_path(selectedIcon) + ')' : 'url(/images/gallery.png)'}">
              <div>{{$t('edit')}}</div>
            </div>

            <b-modal size="xl" centered v-model="showModal" :header-border-variant="headerBorderVariant">

              <template #modal-header>
                  <h2>{{$t('modal_title')}}</h2>
                  <a class="cancel" @click="cancelSelection">
                    &#10006;
                  </a>
              </template>

              <div class="modal-body">
                <b-tabs>

                  <b-tab title="Modèle" class="p-4">
                    <div class="avatars-container">
                      <b-img class="avatar" ref="icon" v-for="(avatarIcon, index) in avatarsCount" :key="index" :src="avatars_path(avatarIcon)" @click="selectIcon(avatarIcon)" :class="{click:selectedIcon == avatarIcon}" fluid rounded="circle" width="100"></b-img>
                    </div>
                  </b-tab>

                  <!-- <b-tab title="Télécharger votre photo">
                    <div class="choices-container">
                      <b-form-file
                        v-model="file1"
                        :state="Boolean(file1)"
                        placeholder="Choisissez une image ou déposez-la ici..."
                        drop-placeholder="Drop file here..." size="lg" accept=".jpg, .png"
                      ></b-form-file>
                    </div>
                  </b-tab> -->
                </b-tabs>
            </div>
              <template #modal-footer>
                <div class="w-100 footer-modal">
                  <b-button variant="secondary" @click="cancelSelection">
                    {{$t('cancel')}}
                  </b-button>
                  <b-button variant="primary" @click="changeIcon">
                    {{$t('register')}}
                  </b-button>
                </div>
              </template>
            </b-modal>
            
          </div>
        </td>
      </tr>
      <tr v-if="device&&device.tracker_config.board_name.startsWith('SCT2v2')">
        <th>{{$t('battery')}}</th>
        <td>
          <span v-if="sct2_battery_request_result">{{ sct2_battery_request_result }}</span>
          <button v-else class="btn btn-sm btn-primary" @click="request_reset_sct2_battery">{{$t('request_reset_sct2_battery_msg')}}</button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { HTTP } from "../http-constants";
import * as nvxlib from "../nvxcommon";
import Multiselect from "vue-multiselect";
import { bus } from "../event-bus";

export default {
  name: "TrackerPanel",
  data: function() {
    return {
      selectedIcon: this.device,
      avatarOnClick: false,
      avatarIcon: -1,
      avatarsCount: [0, 10, 12, 7, 17, 21, 40, 24, 26, 36, 1, 2, 3, 5, 13, 8, 15, 19, 18, 16, 30, 31, 37, 33, 23, 34, 32, 38, 39, 44, 41, 42, 43, 45, 46, 47, 48, 49, 50],
      showModal: false,
      headerBorderVariant: 'light',
      device: null,
      allow_edit: false,
      allow_change_mode: false,
      modes: [],
      freq: {},
      db_name: null,
      calledSave: false,
      current_mode: null,
      allow_sct2_config: false,
      sct2_battery_request_result: null,
      sct2_config: {
        move_loc_period: 10,
        keepalive_period: 240,
        msg: null
      }
    };
  },
  components: { multiselect: Multiselect },
  computed: {
    device_type: function() {
      var _type = this.device.type;
      if (_type == "tracker_01") {
        var board_name = this.device.tracker_config.board_name;
        if (board_name == undefined) {
          return "lwt1";
        }
        if (board_name.startsWith("SCT2")) {
          return "sct2";
        }
        if (board_name.startsWith("LWT2")) {
          return "lwt2";
        }
        return "lwt1";
      } else if (_type == "tracker_02") {
        return "sct";
      }
      return "?";
    }
  },
  methods: {
     avatars_path (icon_id) {
      return nvxlib.icon_path(icon_id)
    },
    changeIcon () {
      let self = this;
      HTTP.patch(
        "/devices/" + this.device.id + "/tracker_config/",
        { icon: self.selectedIcon }
      )
        .then(function(re) {
          if (re.status == 200) {
            self.device.tracker_config = re.data;
            bus.$emit('update_trackers', {device : self.device})
          }
          self.selectedIcon = self.device.tracker_config.icon;
        })
        .catch(function(error) {
          console.log(error);
        });

        this.showModal = false
    },
    selectIcon(index) {
      this.selectedIcon = index
    },
    cancelSelection () {
      this.selectedIcon = this.device.tracker_config.icon
      this.showModal = false
    },
    fetch_mode: function() {
      var self = this;
      HTTP.get("/devices/" + this.device.id + "/modes/")
        .then(function(re) {
          self.freq = re.data;
          self.current_mode = self.device.tracker_config.mode;
          if (self.current_mode !== "235") {
            self.allow_change_mode = true;
          }
          self.modes = self.freq.modes.map(a => a.value);
          let idx = self.modes.indexOf("5");
          if (idx >= 0) {
            self.modes.splice(idx, 1);

          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    request_reset_sct2_battery: function() {
      const self = this;
      if (!window.confirm(app.$t("confirm_request_reset_sct2_battery"))) {
        return
      }
      console.log("request_reset_sct2_battery");
      HTTP.patch(
        "/devices/" + this.device.id + "/battery_reset/",
        { }
      )
        .then(function(re) {
          console.log("request_reset_sct2_battery", re.status)
          if (re.status === 200) {
            console.log("result 200")
            self.sct2_battery_request_result = app.$t('request_reset_sct2_battery_success');
          } else if (re.status === 204) {
            self.sct2_battery_request_result = app.$t('request_reset_sct2_battery_already_sent');
          }
        })
        .catch(function(error) {
          console.log(error);
          self.sct2_battery_request_result = "error";
        });
    },
    mode_label: function(elem) {
      return this.$options.filters.niceMode(elem);
    },
    save_device: function() {
      var self = this;
      self.calledSave = true;
      self.db_name = self.device.name;
      HTTP.patch("/devices/" + this.device.id + "/", this.device)
        .then(function(re) {
        //   self.device = re.data;
          Object.assign(self.device, re.data)
          self.db_name = String(self.device.name);
          bus.$emit('update_trackers', {device : self.device})
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    request_mode_change: function() {
      var self = this;
      HTTP.patch(
        "/devices/" + this.device.id + "/tracker_config/?remote=True",
        { mode: this.current_mode }
      )
        .then(function(re) {
          if (re.status == 200) {
            self.device.tracker_config = re.data;
          }
          self.current_mode = self.device.tracker_config.mode;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    get_sct2_config: function() {
      let self = this;
      console.log("get_sct2_config");
      HTTP.get("/devices/" + this.device.id + "/sct2_config/")
        .then(function(re) {
          self.sct2_config = re.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    request_sct2_change: function() {
      var self = this;
      HTTP.patch(
        "/devices/" + this.device.id + "/sct2_config/?remote=True",
        this.sct2_config
      )
        .then(function(re) {
          if (re.status == 200) {
            self.sct2_config = re.data;
            self.sct2_config.msg = "Change has been successfully requested";
          }
        })
        .catch(function(error) {
          self.sct2_config.msg = "Issue when requesting config change";
          console.log(error);
        });
    }
  },
  watch: {
    showModal: function (newValue) {
      if (!newValue) {
        this.cancelSelection()
      }
    }
  },
  mounted: function() {
    console.log("allow_change_mode", this.allow_change_mode);
    var self = this;
    nvxlib.getUserRole(function(role) {
      if (role === "sub_user") {
        return;
      }
      self.allow_edit = true;
    });
  },
  created: function() {
    bus.$on("tracker_panel", elem => {
      var action = elem.action;
      if (action === "edit") {
        this.allow_sct2_config = false;
        this.sct2_battery_request_result = null;
        this.device = elem.tracker;
        this.selectedIcon = this.device.tracker_config.icon;
        this.db_name = String(this.device.name);

        console.log("device", this.device);
        console.log("Operator", this.device.tracker_status.network_operator);
        if (this.device.tracker_status.network_operator !== "sigfox") {
          if (this.device_type === "sct2") {
            this.allow_sct2_config = true;
            this.get_sct2_config();
          } else if (this.device_type.startsWith("lwt")) {
            this.fetch_mode();
          }
        }
      } else {
        if (this.device && this.device.name.localeCompare(this.db_name) != 0) {
          this.device.name = String(this.db_name);
        }
        this.device = null;
      }
    });
  }
};
</script>

<style lang="scss" scoped>

.profil {
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background-position: center;
  background-size: 100%;
  cursor: pointer;
  transition: transform .5s ease;

  &:hover {
    transform: scale(1.1);
  }

  div {
    width: 85%;
    height: 35px;
    margin-bottom: -12.5px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background-image: url("/images/edit.png");
    background-repeat: no-repeat;
    background-size: contain;
    color: white;
    font-size: .8em;
  }
}

.modal-body  {
  min-height: 654px;
  padding: 0 !important;
}

.avatars-container {
  width: 100%;
  display: flex !important;
  flex-wrap: wrap;
  gap: 1em;
  justify-content: center;

  .avatar {
    cursor: pointer;
    opacity: .5;
    transition: opacity .3s ease;

    // &:before { 
    //   position: relative;
    //   content: "";
    //   display: inline-block;
    //   margin-top: 50px;
    //   width: 10px;
    //   height: 10px;
    //   border: solid 2px red;
    //   z-index: 22;
    // }

    &:hover {
      opacity: 1;
    }
  }
}

.cancel {
  cursor: pointer;
  font-size: 1.5em;
  color: black;
  transition: all .3s ease;

  &:hover {
    transform: rotate(180deg);
  }
}

.choices-container {
  width: 100%;
  height: 60vh;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.footer-modal {
  display: flex;
  gap: 1em;
  justify-content: flex-end;
  align-items: center;
}

.click {
  opacity: 1 !important;
}
</style>